import React, { useRef, useState } from "react";
// import { useDispatch } from "react-redux";
// import { logIn } from "../../store/auth/actions";
import {
  Button,
  Card,
  Divider,
  Form,
  Image,
  Input,
  Modal,
  Space,
  Typography,
} from "antd";
import {
  MobileTwoTone,
  ArrowRightOutlined,
  CrownTwoTone,
  // ExclamationCircleOutlined,
} from "@ant-design/icons";
import "./auth.css";
import logo from "../../assets/images/Logo copy.png";
// import logoOverlay from "./../../assets/images/Logo copy.png"; // Adjust path as needed
import SimpleReactValidator from "simple-react-validator";
// import { isEmpty } from "lodash";
// import api from "../../helpers";
import { ToastContainer, toast } from "react-toastify";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
// import api from "../../helpers";
import { isEmpty } from "lodash";
// import axios from "axios";
import axiosInstance, { setAuthToken } from "../../helpers";
// import axios from "axios";

const { Title } = Typography;

const Login = () => {
  const location = useLocation();
  const { id } = useParams();
  const history = useHistory();
  //state values
  const [loginData, setLoginData] = useState({
    phoneNumber: "",
    forgotPhoneNumber: "",
    secretKey: "",
  });

  const [error, setError] = useState("");
  const [forgotError, setForgotError] = useState("");
  const [forgotValidations, setForgotValidations] = useState("");
  const [forgotModal, setForgotModal] = useState(false);

  console.log(error, "login error");
  console.log(location, "location");
  const handlePhoneNumberChange = (e) => {
    const { name, value } = e.target;

    const validationRules = {
      phoneNumber: /^[0-9]*$/,
      forgotPhoneNumber: /^[0-9]*$/,
      secretKey: /^[0-9]*$/,
    };
    if (validationRules[name]) {
      if (validationRules[name].test(value) || value === "") {
        setLoginData({
          ...loginData,
          [name]: value,
        });
      }
    } else {
      setLoginData({
        ...loginData,
        [name]: value,
      });
    }
  };

  // State maintenance

  //validations
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();

  console.log(id, "id");
  const registerPagePath =
    !isEmpty(id) || id !== undefined || id !== "login" ? `/${id}` : "/#";

  //Login
  const signIn = () => {
    if (simpleValidator.current.allValid()) {
      const user = {
        mobile: loginData.phoneNumber,
        lpin: loginData.secretKey,
        // otp: otpValue,
      };
      // axios.get('/sanctum/csrf-cookie')

      axiosInstance
        .post("/Api/member_login", user)
        .then((res) => {
          console.log(res.data, "response in register");
          localStorage.setItem("sessionUser", JSON.stringify(res));
          localStorage.setItem("authUser", res.data.data);
          setAuthToken(res.data && res.data.data && res.data.data.token);
          history.push("/dashboard");
          return res.data;
        })
        .catch((error) => {
          setError(error);
          return Promise.reject(error);
        });

      // axiosInstance
      //   .post("/Api/member_login", user)
      //   .then((res) => {
      //     console.log(res.data, "response in register");
      //     localStorage.setItem("sessionUser", JSON.stringify(res));
      //     localStorage.setItem("authUser", res.data.data);
      //     history.push("/dashboard");
      //     return res.data;
      //   })
      //   .catch((error) => {
      //     setError(error);
      //     return Promise.reject(error);
      //   });
      // dispatch(logIn(user));
      // history.push("/dashboard");
      console.log(user, "user");
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
    }
  };

  //Forgot password
  const forgotPassword = () => {
    if (!isEmpty(loginData.forgotPhoneNumber)) {
      const user = {
        mobile: loginData.forgotPhoneNumber,
      };
      // axios.get('/sanctum/csrf-cookie')

      axiosInstance
        .post("/Api/forget_password", user)
        .then((res) => {
          console.log(res.data, "response in register");
          localStorage.setItem("sessionUser", JSON.stringify(res));
          localStorage.setItem("authUser", res.data.data);
          // history.push("/dashboard");

          setForgotModal(false);
          setForgotValidations(false);
          setForgotError("");
          toast.info(res.data.message);
          return res.data;
        })
        .catch((error) => {
          setForgotError(error);
          return Promise.reject(error);
        });

      console.log(user, "user");
    } else {
      setForgotValidations(true);
      setForgotModal(true);
    }
  };

  console.log(forgotError, "forgotError");

  return (
    <div className="flex-container" style={{ overflow: "hidden" }}>
      <Card className="login-card-details">
        <div className="main-login-image flex justify-center">
          <div className="mt-[70px] bg-[transparent]">
            <div className="mt-2">
              <h1
                style={{
                  padding: "7px",
                  borderRadius: "10px",
                  border: "none",
                  background: "#69000070",
                  // boxShadow: "1px 1px 13px 1px #8d8d8d8f",
                }}
                className="text-[20px] font-bold text-[#ffffff]"
              >
                A Loyalty Program that pays you back
              </h1>
            </div>
          </div>
        </div>
      </Card>

      <Card
        style={{
          flex: "1",
          margin: "0px 0px",
          backgroundColor: "#f1f1f1",
          height: "auto",
          overflow: "hidden",
        }}
      >
        <div className="font-sans login-form-card-details">
          <Image
            src={logo}
            preview={false}
            style={{
              alignContent: "flex-start",
              width: "150px",
              height: "75px",
              borderRadius: "2px",
            }}
          />
        </div>

        <div className="login-form-basic">
          <Title
            level={4}
            style={{
              display: "flex",
              justifyContent: "flex-start",
              margin: "30px 0px 5px 32px",
              fontSize: "22px",
              fontWeight: "800", // Semi-bold

              fontFamily: "Roboto, sans-serif",
            }}
          >
            Login
          </Title>
        </div>

        <div style={{ textAlign: "left" }} className="login-form-basic">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              marginLeft: "32px",
              fontFamily: "Roboto, sans-serif",
            }}
          >
            <ArrowRightOutlined
              style={{ fontSize: "14px", marginRight: "4px" }}
            />
            <Typography.Text
              style={{ fontSize: "14px", fontFamily: "Roboto, sans-serif" }}
            >
              Login by providing your mobile number
            </Typography.Text>
          </div>
        </div>
        <div className="w-[100] text-center text-[red]">
          {!isEmpty(error) && error.response
            ? error.response.data.messages.error
            : ""}
        </div>
        <Form
          name="basic"
          className="login-form-basic"
          labelCol={{ span: 4 }}
          wrapperCol={{ span: 14 }}
        >
          <Form.Item
            name={"Number"}
            rules={[{ message: "Enter Mobile no" }]}
            style={{
              display: "flex",
              justifyContent: "flex-start",
              marginLeft: "28px",
            }}
          >
            <Space.Compact className="flex flex-col">
              <Input
                maxLength={10}
                size="large"
                name="phoneNumber"
                className="login-input-fields"
                inputMode="numeric"
                placeholder="Enter Your Mobile Number"
                value={loginData.phoneNumber}
                onChange={(e) => handlePhoneNumberChange(e)}
                prefix={<MobileTwoTone />}
              />
              <p className="text-start text-[red] mt-1 text[11px]">
                {simpleValidator.current.message(
                  "phoneNumber",
                  loginData.phoneNumber,
                  "required"
                )}
              </p>
            </Space.Compact>
          </Form.Item>

          <Form.Item
            style={{
              display: "flex",
              justifyContent: "flex-start",
              marginLeft: "28px",
            }}
          >
            <Input.Password
              maxLength={4}
              size="large"
              name="secretKey"
              className="login-input-fields"
              inputMode="numeric"
              placeholder="Enter your secret key"
              value={loginData.secretKey}
              onChange={(e) => handlePhoneNumberChange(e)}
              prefix={<CrownTwoTone />}
            />
            <p className="text-start text-[red] mt-1 text[11px]">
              {simpleValidator.current.message(
                "secretKey",
                loginData.secretKey,
                "required"
              )}
            </p>
          </Form.Item>

          <Form.Item
            style={{
              display: "flex",
              justifyContent: "flex-start",
              marginLeft: "28px",
            }}
          >
            <Button
              type="primary"
              htmlType="submit"
              className="login-input-fields"
              style={{
                backgroundColor: "#7b7b7b",
                color: "whitesmoke",
              }}
              onClick={signIn}
            >
              Login
            </Button>
          </Form.Item>
          <div className="login-route">
            <Divider className="w-[100%]">
              <div
                onClick={() => {
                  setForgotModal(true);
                  setLoginData({
                    ...loginData,
                    forgotPhoneNumber: "",
                  });
                }}
                className="cursor-pointer font-semibold text-[#3498db] mt-1"
              >
                {/* Existing User ?{" "} */}
                {/* <Link
                  to={{
                    pathname: "/forgot-password",
                  }}
                > */}
                Forgot Password
                {/* </Link> */}
              </div>
            </Divider>
          </div>
          <div className="register-login-route mb-[-28px]">
            {/* <Divider className="w-[100%] mb-4">Or</Divider> */}
            {location &&
            location.state &&
            location.state === "without-referral" ? (
              ""
            ) : (
              <div className="font-semibold register-button">
                Create a new Account.?
                <Link
                  to={{
                    pathname: registerPagePath,
                  }}
                  style={{
                    // border: "1px dashed #3498db",
                    fontSize: "16px",
                  }}
                  className={
                    location &&
                    location.state &&
                    location.state === "without-referral"
                      ? "opacity-1 pointer-events-none text-[#3498db] underline ml-1"
                      : "text-[#3498db] underline ml-1"
                  }

                  // onMouseEnter={
                  //   location &&
                  //   location.state &&
                  //   location.state === "without-referral"
                  //     ? toast.warning(
                  //         "Without referral, register process should not be enabled"
                  //       )
                  //     : ""
                  // }
                >
                  Register
                </Link>
              </div>
            )}
          </div>
        </Form>
      </Card>
      <Modal
        title="Forgot Password"
        open={forgotModal}
        onOk={() => {
          forgotPassword();

          // history.push("/parties");
        }}
        closeIcon
        maskClosable={false}
        rootClassName="p-15"
        okText={"Forgot Password"}
        cancelText={"Cancel"}
        onCancel={() => {
          setForgotModal(false);
          setForgotError("");
        }}
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn />
            <OkBtn />
          </>
        )}
        width={500}
      >
        <Divider style={{ width: "110.5%", marginLeft: "-24px" }} />
        <div className="w-[100%] mt-6 mb-10">
          <p className="text-center text-[red] mb-2 text[11px]">
            {!isEmpty(forgotError) ? forgotError.message : ""}
          </p>
          <Input
            maxLength={10}
            size="large"
            name="forgotPhoneNumber"
            className="p-3 bg-[white]"
            inputMode="numeric"
            placeholder="Enter Your Mobile Number"
            value={loginData.forgotPhoneNumber}
            onChange={(e) => handlePhoneNumberChange(e)}
            prefix={<MobileTwoTone />}
          />
          <p className="text-start text-[red] mt-1 text[11px]">
            {isEmpty(loginData.forgotPhoneNumber) && forgotValidations
              ? "The phone number field is required"
              : ""}
          </p>
        </div>
        {/* <Divider
          style={{ borderWidth: "0.2px", width: "110.5%", marginLeft: "-24px" }}
        /> */}
      </Modal>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        style={{
          fontSize: "12px",
        }}
      />
    </div>
  );
};

export default Login;
